import { ElsiReminderPolicy } from '../interfaces/elsi-reminders.interface';

export const ELSI_REMINDERS_DEFAULT_POLICY: Omit<
  ElsiReminderPolicy,
  'id' | 'accountId' | 'companyId'
> = {
  enabled: true,
  allowSenderOverride: true,
  firstDelayDays: 2,
  intervalDays: 3,
  maxRounds: 3,
  emailEnabled: true,
  smsEnabled: false,
};

export const ELSI_REMINDERS_LIMITS = {
  firstDelayDays: { min: 1, max: 30 },
  intervalDays: { min: 0, max: 30 },
  maxRounds: { min: 1, max: 60 },
};

export const ELSI_REMINDERS_TOOLTIP_MAX_ROUNDS = `The number of rounds to send reminders before stopping.\n\nIf not set, the reminders will be sent indefinitely.`;

export const ELSI_REMINDERS_TOOLTIP_FIRST_DELAY_DAYS = `The number of days to wait before sending the first reminder.`;

export const ELSI_REMINDERS_TOOLTIP_INTERVAL_DAYS = `The number of days to wait before sending the interval reminder.`;

export const ELSI_REMINDERS_TOOLTIP_ALLOW_SENDER_OVERRIDE = `Allow the sender override this policy for individual packages.`;

/**
 * For now we are hiding SMS due to complex logic in granting SMS consent.
 * Once SMS consent logic is implemented, display SMS and remove this constant.
 */
export const ELSI_REMINDERS_HIDE_SMS = true;
